import i18next from 'i18next'

export const componentDetailPath = (id: number, name: string) =>
  `${
    i18next.language == 'en' ? '/en/components/' : '/nl/componenten/'
  }${id}-${name.split(' ').join('-').toLowerCase().replace('%', '')}`

export const componentEditPath = (id: number) =>
  `${
    i18next.language == 'en' ? '/en/components/' : '/nl/componenten/'
  }${id}/edit`
